import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/91a67e0c5dc05e1fff2ed945ac55f541.jpg',
      title: '岡山市で理想のマイホームを実現',
      subtitle: '地域密着20年の実績で、あなたの夢の住まい探しを全力サポート'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20residential%20street%20with%20modern%20houses%2C%20clean%20sidewalks%2C%20mature%20trees%20lining%20the%20road%2C%20peaceful%20neighborhood%20atmosphere%2C%20contemporary%20architecture%2C%20natural%20daylight%2C%20well-maintained%20properties%2C%20no%20text%20signs%20or%20written%20content%20visible%2C%20suburban%20tranquility%20with%20beautiful%20landscaping&width=1920&height=800&seq=hero2-new&orientation=landscape',
      title: '最短1週間で現金化可能',
      subtitle: '急な転勤や相続でお困りの方、迅速な不動産買取で解決します'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20residential%20area%20with%20traditional%20and%20modern%20homes%2C%20tree-lined%20streets%2C%20peaceful%20morning%20atmosphere%2C%20clean%20urban%20planning%2C%20contemporary%20neighborhood%20design%2C%20natural%20lighting%2C%20well-maintained%20community%2C%20no%20visible%20text%20or%20signage%20anywhere%2C%20serene%20residential%20environment&width=1920&height=800&seq=hero3-new&orientation=landscape',
      title: '無料査定で適正価格をご提案',
      subtitle: '経験豊富な専門スタッフが、お客様の大切な資産を正確に評価'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-black/30" />
          
          <div className="relative h-full flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="max-w-3xl">
                <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                  {slide.title}
                </h2>
                <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
                  {slide.subtitle}
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button size="lg" className="text-lg px-8 py-4">
                    <i className="ri-phone-line mr-2"></i>
                    086-012-3456
                  </Button>
                  <Button variant="outline" size="lg" href="#contact" className="text-lg px-8 py-4 bg-white/10 border-white text-white hover:bg-white hover:text-blue-600">
                    <i className="ri-mail-line mr-2"></i>
                    お問い合わせ
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white text-3xl transition-colors"
      >
        <i className="ri-arrow-left-line"></i>
      </button>
      <button
        onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white text-3xl transition-colors"
      >
        <i className="ri-arrow-right-line"></i>
      </button>
    </section>
  );
}
